import { render, staticRenderFns } from "./AdminFunctions.vue?vue&type=template&id=0c0c6fb2"
import script from "./AdminFunctions.vue?vue&type=script&lang=js"
export * from "./AdminFunctions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports